<template>
  <div class="form">
    <div class="show-bottom-border">
      <div class="form-ih7">
        <ih7 :cfg="{label:'活动基础信息'}"></ih7>
      </div>
    </div>
    <div class="show-bottom-border">
      <div class="form-ih7">
        <ih7 :cfg="{label:'活动表单设置'}"></ih7>
      </div>
      <div class="align-left second-level-btn">
        <div ref="showAddAttrP" style="display: inline-block;">
          <Button type="ghost" @click="showAddAttr">添加字段</Button>
        </div>
      </div>
      <div class="dynamic-attr-content" ref="dynamicAttrContent">
        <div v-for="(item,index) in mainList" :key="index">
          <div class="property-card-p property-card">
            <div class="property-delete">
              <Button type="text" icon="trash-alt" @click="deleteAttr(index)"></Button>
            </div>
            <div class="property-form">
              <div>
                <component :attrObj="item" :is="item.questionType"></component>
              </div>
            </div>
            <div class="property-set property-card">
              <div>
                <div class="form-item-label">
                  <span>排序</span>
                </div>
                <div class="form-item-content">
                  <Input size="default" v-model="item.no"/>
                </div>
              </div>
              <div>
                <div class="form-item-label">
                  <span>是否必填</span>
                </div>
                <div class="form-item-content">
                  <Checkbox v-model="item.mustFlag"></Checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="showMenu"
      v-click-outside.capture="onClickOutside"
      class="i-poptip-popper tree-o-menu"
      ref="treeOpMenu"
    >
      <div class="tree-o-menu-content i-poptip-content">
        <div class="i-poptip-arrow"></div>
        <div class="tree-o-menu-btn">
          <Button class="btn-ellipsis-h" type="ghost" @click="addAttr('dynamicFormRadio')">单选</Button>
        </div>
        <div class="tree-o-menu-btn">
          <Button class="btn-ellipsis-h" type="ghost" @click="addAttr('dynamicFormCheckbox')">多选</Button>
        </div>
        <div class="tree-o-menu-btn">
          <Button class="btn-ellipsis-h" type="ghost" @click="addAttr('dynamicFormInput')">单行文本</Button>
        </div>
        <div class="tree-o-menu-btn">
          <Button class="btn-ellipsis-h" type="ghost" @click="addAttr('dynamicFormTextarea')">多行文本</Button>
        </div>
        <div class="tree-o-menu-btn">
          <Button class="btn-ellipsis-h" type="ghost" @click="addAttr('dynamicFormFile')">附件</Button>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style>
.vibrant-rubik-cube .form .form-item-label {
  padding-right: 10px;
  min-width: 80px;
  display: inline-block;
  text-align: right;
}
.vibrant-rubik-cube .form .form-item-content {
  width: 56%;
  min-width: 200px;
  display: inline-block;
  margin: 10px 0px;
}
.vibrant-rubik-cube .form .dynamic-attr-content {
  margin-top: 10px;
}
.property-card-p {
  display: flex;
}
.property-card {
  border: 1px solid #dddee1;
  border-color: #e9eaec;
  padding: 15px;
}
.property-card:hover {
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-color: #eee;
}
.property-delete {
  margin-top: -15px;
}
.vibrant-rubik-cube .form .property-form {
  min-width: 400px;
  flex: 1;
}
.vibrant-rubik-cube .form .property-set {
  flex: 1;
}
</style>

<script>
import { directive as clickOutside } from "@/utils/component/v-click-outside-x";
import popper from "../../../../static/comjs/popper.min.js";
import dynamicFormRadio from "./dynamicAttr/radio";
import dynamicFormCheckbox from "./dynamicAttr/checkbox";
import dynamicFormInput from "./dynamicAttr/input";
import dynamicFormTextarea from "./dynamicAttr/textarea";
import dynamicFormFile from "./dynamicAttr/file";
export default {
  components: {
    dynamicFormRadio,
    dynamicFormCheckbox,
    dynamicFormInput,
    dynamicFormTextarea,
    dynamicFormFile,
  },
  directives: { clickOutside },
  data() {
    return {
      dataList: [],
      formCustom: {},
      showMenu: false,
      mainList: [
        {
          questionType: "dynamicFormCheckbox",
          title: "",
          desc: "",
          mustFlag: "",
          optionList: [
            {
              optionCode: "",
              optionContent: ""
            }
          ]
        }
      ],
      groupNameList: [],
      ruleValidate: {
        // organization: [
        //     { required: true, message: '机构名称不能为空', trigger: 'blur' }
        // ]
      }
    };
  },
  created() {
    this.initData();
    this.ruleValidate = {
      organization: [
        {
          required: true,
          message: this.$t("finance.fundAccountManage.organizationNoEmpty"),
          trigger: "blur"
        }
      ],
      accountNo: [
        {
          required: true,
          message: this.$t("finance.fundAccountManage.accountNotEmpty"),
          trigger: "change"
        }
      ]
    };
  },
  //初始化后调用
  mounted: function() {},
  methods: {
    showAddAttr(e) {
      this.showMenu = true;
      this.$nextTick(function() {
        let p = new popper(this.$refs.showAddAttrP, this.$refs.treeOpMenu, {
          flipVariations: true,
          placement: "bottom-start"
        });
      });
    },
    onClickOutside() {
      this.showMenu = false;
    },
    deleteAttr(index) {
      this.mainList.splice(index, 1);
    },
    addAttr(questionType) {
      let obj = {
        questionType: questionType,
        title: "",
        desc: "",
        mustFlag: "",
        optionList: [
          {
            optionCode: "",
            optionContent: ""
          }
        ]
      };
      this.mainList.push(obj);
    },
    //获取form表单
    getFormData() {
      return false;
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit("handleClose", tabItemName);
    },
    //编辑页面给表单赋值
    setFormData(name, data) {
      name = name || "formCustom";
      this[name] = data;
      this.disabled = true;
    },
    //加载店铺组
    initData() {
      let self = this;
      self.$api.post({
        sc: "merchant",
        url: "channelManage/listByChannelGroupNames",
        success: r => {
          self.groupNameList = r.result || [];
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/form.vue